import { Box, Grid, GridItem, Text } from '@chakra-ui/react'
import React from 'react'
import ChangePasswordTextfields from '../../../Components/TextFields/ChangePasswordTextfields'

const ChangePassword = () => {
  return (
    <Box w='100%'>
      <Text fontSize='20px' color='#333' marginLeft='30px' marginBottom='10px'>
        Change Password
      </Text>
      <Grid templateColumns={'repeat(12, 1fr)'} gap={3}>
        <GridItem colSpan={{base:"12",lg:"6"}}>
          <Box color='#315B84' background='#FFFFFF' padding='20px 25px 15px 25px' w='100%' borderRadius='15px'>
            <ChangePasswordTextfields />
          </Box>
        </GridItem>
      </Grid>
    </Box>
  )
}

export default ChangePassword